import React, { useCallback, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ScrollableSteps from '../../../components/ScrollableStepsAlt/ScrollableSteps'
import { twMerge } from 'tailwind-merge'
import SectionWithTag from '../../../components/SectionWithTag'
import { useIsMobile } from '../../../utils/helpers'
import { Color } from '../../../utils/constants'

const id = 'page.epp.segments'

const steps = [
    {
        id: `${id}.LYNX75Y`,
        slug: 'LYNX75Y',
    },
    {
        id: `${id}.LYNX58M`,
        slug: 'LYNX58M',
    },
    {
        id: `${id}.LYNX15S`,
        slug: 'LYNX15S',
    },
]

const Segments = () => {
    const [isVisible, setIsVisible] = useState(false)
    const [padding, setPadding] = useState<number | undefined>(undefined)
    const isMobile = useIsMobile()

    const calculatePadding = useCallback(
        (ref: HTMLDivElement) => {
            if (!isMobile) {
                setPadding(ref.getBoundingClientRect().right)
            } else {
                setPadding(undefined)
            }
        },
        [isMobile],
    )
    return (
        <div
            className={twMerge(
                'border-t border-black/10 relative transition duration-700 pt-16 md:pt-30',
                isVisible ? 'bg-green-light' : 'bg-white',
            )}
        >
            <SectionWithTag
                tag={{ id: `${id}.tag` }}
                resizeCallback={calculatePadding}
                className=' 3xl:max-w-screen-2xl mx-auto md:pb-20'
            >
                <div>
                    <div className='max-w-[830px] mx-auto text-left md:text-center pt-16 md:p-0'>
                        <FormattedMessage id={id} tagName='h2' />
                    </div>
                </div>
            </SectionWithTag>
            <ScrollableSteps
                steps={steps}
                padding={padding}
                setIsVisible={setIsVisible}
                color={Color.GREEN_LIGHT}
            />
        </div>
    )
}

export default Segments
